/**
 * @description
 * Objeto rols
 */

export class Rols {
    public id:number = null;
    public code:string;
    public desc:string;
    public priority:number = null;

    public operacion1:boolean = false;
    public operacion2:boolean = false;
    public operacion3:boolean = false;


    public quickview: number = null;
    public rolldap: string;
    public proveidor: number = null;

    constructor() {}
  
}